<template>
  <paginate
      v-model="valData"
      :page-count="pageCount"
      :page-range="3"
      :margin-pages="2"
      :prev-text="'قبلی'"
      :next-text="'بعدی'"
      :container-class="'pagination'"
      :page-class="'page-item'"/>
</template>

<script>
  import Paginate from 'vuejs-paginate'

  export default {
    components: {
      Paginate
    },

    props: {
      value: {
        type: Number,
        default: 1
      },
      pageCount: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {}
    },
    methods: {},
    computed: {
      valData: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
  }
</script>

